import { Validator } from "@itk/react-form";
import { hasValue, hasValueAndNotEmpty } from "@itk/typescript-utils";
import { hasToBeEqualTo, passwordRequirements } from "./validators.i18n";

export const isEqual =
  (otherValue: string | null, otherField: string): Validator<string> =>
  value =>
    hasValueAndNotEmpty(value) && value !== otherValue ? hasToBeEqualTo(otherField) : undefined;

export const password: Validator<string> = value => (hasValue(value) && !/^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?[^\s\da-zA-Z])\S{5,}$/.test(value) ? passwordRequirements() : undefined);
